
import React, { useEffect, useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function SubscriptionPage() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // =========================
  // 📦 Fetch Plans
  // =========================
  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const res = await API.post("/plans/"); // ✅ FIXED GET
      console.log("Fetched plans:", res); // Debug log
      setPlans(res.data);
    } catch (error) {
      console.error("Failed to fetch plans", error);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // 💳 Handle Payment
  // =========================
  const handleBuy = async (plan) => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please login first");
      window.location.href = "/login";
      return;
    }

    try {
      const res = await API.post("/create-order", {
        plan: plan.name,
      });

      const { order_id, amount, key } = res.data;

      const options = {
        key,
        amount,
        currency: "INR",
        name: "CarePlus",
        description: `${plan.name} Plan`,
        order_id,

        handler: async function (response) {
          try {
            await API.post("/verify-payment", {
              ...response,
              plan: plan.name,
            });

            alert("Payment Successful 🎉");
            window.location.href = "/"; // safe redirect

          } catch (err) {
            console.error("Verification failed", err);
            alert("Payment verification failed");
          }
        },

        prefill: {
          name: "User",
          email: "user@email.com",
        },

        theme: { color: "#2563eb" },
      };

      new window.Razorpay(options).open();

    } catch (err) {
      console.error("Payment initiation failed", err);
      alert("Something went wrong");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
  <Navbar />

  <div className="pt-24 pb-16 px-4 flex flex-col items-center">
      {/* ========================= */}
      {/* 🔥 HEADER */}
      {/* ========================= */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-blue-700 mb-2">
          Subscription Plans
        </h1>
        <p className="text-gray-600 text-lg">
          Simple pricing. Powerful features.
        </p>
      </div>

      {/* ========================= */}
      {/* 🔄 LOADING */}
      {/* ========================= */}
      {loading ? (
        <p className="text-gray-500 text-lg">Loading plans...</p>
      ) : (
        <div className="flex flex-wrap justify-center gap-8 w-full max-w-6xl">
          {plans.map((plan) => {

            const features = [
              "AICA E Rx: Sound & Digital Prescription",
              "1 Credit per Prescription",
              "SMS / WhatsApp Delivery",
              "Inclusive GST",
            ];

            return (
              <div
                key={plan.id}
                className={`relative w-80 bg-white rounded-2xl shadow-xl border p-8 transition transform hover:-translate-y-2 hover:shadow-2xl 
                ${plan.is_popular ? "border-2 border-blue-600 scale-105" : "border-blue-100"}`}
              >

                {/* Badge */}
                {plan.is_popular && (
                  <span className="absolute -top-3 right-4 bg-blue-600 text-white text-xs px-3 py-1 rounded-full shadow">
                    Most Popular
                  </span>
                )}

                {/* Plan Name */}
                <h2 className="text-xl font-bold text-blue-700 text-center">
                  {plan.name.toUpperCase()}
                </h2>

                {/* Price */}
                <div className="text-center mt-4">

  {/* Price */}
  <div className="flex justify-center items-end gap-1">
    <span className="text-lg text-gray-400">₹</span>
    <span className="text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
      {plan.price}
    </span>
  </div>

  {/* Divider */}
  <div className="w-10 h-1 bg-blue-500 mx-auto rounded-full mt-2"></div>

  {/* Subtext */}
  <p className="text-xs text-gray-500 mt-2">
    Best value plan
  </p>

</div>

  {/* Subtext */}


                {/* Highlight */}
                {/* <p className="text-center text-lg font-semibold text-blue-600 mt-3">
                  {plan.credits} Prescriptions Included
                </p> */}
                {/* Highlight */}
<div className="text-center mt-3 space-y-1">

  {/* Credits */}
  <p className="text-lg font-semibold text-blue-600">
    {plan.credits} Prescriptions Included
  </p>

  {/* Price per prescription */}
    <p className="text-sm text-gray-500">
  ₹{
    plan.name === "basic"
      ? 60
      : plan.name === "pro"
      ? 50
      : 50
  } per Prescription
</p>


</div>
                




                {/* Features */}
                <ul className="mt-6 space-y-3 text-gray-700 text-sm">
                  {features.map((item, index) => (
                    <li key={index} className="flex items-center gap-2">
                      <span className="text-green-500">✔</span>
                      {item}
                    </li>
                  ))}
                </ul>

                {/* Button */}
                <button
                  onClick={() => handleBuy(plan)}
                  className={`w-full mt-6 py-3 rounded-lg font-semibold transition-all duration-200 
                  ${
                    plan.is_popular
                      ? "bg-blue-600 text-white hover:bg-blue-700"
                      : "bg-blue-100 text-blue-800 hover:bg-blue-200"
                  }`}
                >
                  Buy Now
                </button>
              </div>
            );
          })}
        </div>
      )}
      </div>
    </div>
  );
}